import React from 'react';
import PropTypes from 'prop-types';

import FormField from '../../../../component-library/form-field';
import ButtonIcon from '../../../../component-library/button-icon';

const CommentInput = ({
	placeholder,
	formAction,
	formValue,
	formError,
	buttonAction,
	maxCommentLength,
}) => {
	const handleKeyPress = e => {
		if (e.key === 'Enter') {
			buttonAction();
		}
	};

	return (
		<div className="comments__new-message-container">
			<div>
				<FormField
					type="text"
					placeholder={placeholder}
					action={e => { formAction(e.target.value); }}
					keyPressAction={e => { handleKeyPress(e); }}
					id="message_field"
					name="message_field"
					value={formValue}
					error={formError}
					fullWidth
					maxLength={maxCommentLength}
				/>
			</div>
			<div>
				<ButtonIcon
					icon="paper-plane"
					title="Send"
					classes="comments__new-message-button"
					onClick={() => buttonAction()}
				/>
			</div>
		</div>
	);
};

export default CommentInput;

CommentInput.propTypes = {
	placeholder: PropTypes.string.isRequired,
	formAction: PropTypes.func.isRequired,
	formValue: PropTypes.string.isRequired,
	formError: PropTypes.string.isRequired,
	buttonAction: PropTypes.func.isRequired,
	maxCommentLength: PropTypes.number.isRequired,
};
